import { Box } from "@mui/material";
import { PriorityHigh } from "@mui/icons-material";

const WarningMessage = ({ message }) => {
    return (
        <Box sx={{
            p: 2,
            width: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            fontSize: '1.1rem', 
            backgroundColor: '#E84545', 
            color: 'white', 
            borderRadius: '15px',
        }}>
            <Box>
                {message}
            </Box>
            <Box sx={{marginLeft: 'auto'}}>
                <PriorityHigh/>
            </Box>
        </Box>
    );
}

export default WarningMessage;